"use client";

import { Button } from "@relume_io/relume-ui";
import { RxChevronRight } from "react-icons/rx";
import { Link } from "react-router-dom";
export function Stats25() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="mb-12 grid grid-cols-1 gap-y-5 md:mb-18 md:grid-cols-2 md:gap-x-12 lg:mb-20 lg:gap-x-20">
          <div>
            <h2 className="text-5xl font-bold md:text-7xl lg:text-8xl">
              Our Commitment to Animal Welfare
            </h2>
          </div>
          <div>
            <p className="md:text-md">
            We are dedicated to rescuing and caring for animals in need. Our passionate team works tirelessly to provide veterinary care, food, and shelter. Join us in making a difference in their lives.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
            <Link to="/donation">
              <Button style={{ color: "white", background: "#147754" }} title="Donate" variant="secondary">
                Donate
              </Button>
              </Link>
              <Link to="/volunteer">
              <Button
                title="Volunteer"
                variant="link"
                size="link"
              >
                Volunteer
              </Button>
              </Link>
              {<RxChevronRight />}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-y-8 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-12">
          <div className="border border-border-primary p-8">
            <p className="mb-8 text-10xl font-bold leading-[1.3] md:mb-10 md:text-[4rem] lg:mb-12 lg:text-[5rem]">
              10+
            </p>
            <h3 className="text-md font-bold leading-[1.4] md:text-xl">
              Animals Rescued
            </h3>
            <p className="mt-2">
              Providing shelter and care for rescued animals.
            </p>
          </div>
          <div className="border border-border-primary p-8">
            <p className="mb-8 text-10xl font-bold leading-[1.3] md:mb-10 md:text-[4rem] lg:mb-12 lg:text-[5rem]">
              300+
            </p>
            <h3 className="text-md font-bold leading-[1.4] md:text-xl">
              Meals Served
            </h3>
            <p className="mt-2">Nourishing the hungry and abandoned animals.</p>
          </div>
          <div className="border border-border-primary p-8">
            <p className="mb-8 text-10xl font-bold leading-[1.3] md:mb-10 md:text-[4rem] lg:mb-12 lg:text-[5rem]">
              50+
            </p>
            <h3 className="text-md font-bold leading-[1.4] md:text-xl">
              Veterinary Treatments Provided
            </h3>
            <p className="mt-2">
              Ensuring health and wellness for every animal.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
